import { Component, NgModule, OnInit } from "@angular/core";
import { AuthService } from "../../auth/auth.service";
import { ScreenSizeService } from "../../services/screen-size.service";
import { MatDialog } from "@angular/material/dialog";
import { MOesWorkspaceSelectorComponent } from "../../modules/mobile/components/oes-workspace-selector/m-oes-workspace-selector.component";
import { SidebarService } from "../../services/sidebar.service";
import { permissions } from "../../permissions";

@Component({
  selector: "app-header",
  templateUrl: "./app-header.component.html",
  providers: [],
})
@NgModule({
  imports: [],
})
export class AppHeaderComponent implements OnInit {
  public companyName = "Comparatio";
  public companyLogo = "/img/comparatiologo.png";

  public permissions = permissions;
  public isMobileScreen: boolean;
  private screenSizeService: ScreenSizeService;

  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private sidebarService: SidebarService
  ) {
    this.companyName = authService.companyName;
    this.companyLogo = authService.companyLogo;
  }

  ngOnInit() {
    this.screenSizeService = ScreenSizeService.getInstance();
    this.isMobileScreen = this.screenSizeService.isMobileScreen;

    this.sidebarService.init(!this.isMobileScreen);
  }

  loadWorkspaceSelector() {
    this.dialog.open(MOesWorkspaceSelectorComponent, {
      width: "90%",
      maxWidth: window.innerWidth - 40 + "px",
      role: "dialog",
      data: {},
      hasBackdrop: true,
      disableClose: true,
    });
  }

  appSidebarToggle() {
    this.sidebarService.toggleStatus();
    setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
  }

  appMobileSidebarToggle() {
    this.sidebarService.toggleStatus();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-header/app-header.component.ts